import { useUser } from 'context/User'

export default useUser
export { useUser }
